import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CustomLink from "../components/CustomButton/CustomLink";
import EduHeader from "../components/Header/EduHeader";
import OuterFooter from "../components/Footer/OuterFooter";
import Faq from "../components/Faq/Faq";
import { initGA, logPageView, logEvent } from "../components/Analytics";
import GoogleStartupLogos from "../components/googleStartupLogos/GoogleStartupLogos";
import SuccessStories from "../components/SuccessStories/SuccessStories";
import PricingPlans from "../components/PricingPlans/PricingPlans";
import AITeachers from "../components/AITeachers/AITeachers";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import emailjs from '@emailjs/browser';

const EducationPage = () => {
  const [audienceType, setAudienceType] = useState("students");
  const location = useLocation();

  const handleAudienceToggle = (type) => {
    setAudienceType(type);
    logEvent("Audience Toggle", "Click", type);
  };

  const scrollToContactForm = (
    e,
    eventLabel = "Header - Book Pilot Program"
  ) => {
    e.preventDefault();
    const contactForm =
      document.querySelector(".get-in-touch-section") ||
      document.getElementById("contact-form");
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: "smooth" });
    }
    logEvent("CTA", "Click", eventLabel);
  };
  
  const scrollToPricing = (e) => {
    e.preventDefault();
    const pricingSection = document.getElementById("pricing-section") || document.querySelector(".pricing-plans-section");
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: "smooth" });
    }
    logEvent("Navigation", "Click", "Header - Pricing");
  };

  const scrollToAITeachers = (e) => {
    e.preventDefault();
    const aiTeachersSection = document.getElementById("ai-teachers-section");
    if (aiTeachersSection) {
      aiTeachersSection.scrollIntoView({ behavior: "smooth" });
    }
    logEvent("Navigation", "Click", "Meet Our AI Teachers");
  };

  useEffect(() => {

    if (location.state?.scrollToContact) {
      setTimeout(() => {
        const contactForm =
          document.querySelector(".get-in-touch-section") ||
          document.getElementById("contact-form");
        if (contactForm) {
          contactForm.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
    
    if (window.location.hash === "#contact-form") {
      setTimeout(() => {
        const contactForm =
          document.querySelector(".get-in-touch-section") ||
          document.getElementById("contact-form");
        if (contactForm) {
          contactForm.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    } else if (window.location.hash === "#pricing-section") {
      setTimeout(() => {
        const pricingSection = document.getElementById("pricing-section") || 
                              document.querySelector(".pricing-plans-section");
        if (pricingSection) {
          pricingSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }

    initGA();
    logPageView();
  
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  // const handlePlayPause = () => {
  //   setIsPlaying(!isPlaying);
  // };
  // const toggleMute = () => {
  //   videoRef.current.muted = !videoRef.current.muted;
  //   setIsMuted(videoRef.current.muted);
  // };

  // useEffect(() => {
  //   if (isPlaying) {
  //     videoRef.current.play();
  //   } else {
  //     videoRef.current.pause();
  //   }
  // }, [isPlaying]);


  return (
    <div className="education-page">
      <EduHeader scrollToPricing={scrollToPricing} />
      <main className="education-page-main">
        <section className="banner-section">
          <div className="container">
            <div className="banner-wrapper">
              <div>
                <div className="platform-labels">
                  <span className="platform-label">
                    AI-Powered Learning Platform
                  </span>
                  <span className="platform-label primary">
                    For Students & Institutions
                  </span>
                </div>

                <h1 className="banner-title">
                  Learn Smarter With{" "}
                  <span className="highlight">AI Teachers</span> That Understand
                  You
                </h1>

                {audienceType === "students" ? (
                  <p className="banner-text">
                    Personalized learning experiences with AI teachers that
                    adapt to your style, provide instant feedback, enable
                    unlimited practice, and track your progress efficiently.
                  </p>
                ) : (
                  <p className="banner-text">
                    Enhance your institution with AI-powered teaching assistants
                    that automate assessment, provide data-driven insights, and
                    improve educational outcomes for all your students.
                  </p>
                )}

                <div className="audience-toggle">
                  <button
                    className={audienceType === "students" ? "active" : ""}
                    onClick={() => handleAudienceToggle("students")}
                  >
                    For Students
                  </button>
                  <button
                    className={audienceType === "institutions" ? "active" : ""}
                    onClick={() => handleAudienceToggle("institutions")}
                  >
                    For Institutions
                  </button>
                </div>

                <div className="cta-buttons">
                  <CustomLink
                    linkText={
                      audienceType === "students"
                        ? "Start Learning Free"
                        : "Schedule a Demo"
                    }
                    LinkTo={
                      audienceType === "students"
                        ? "https://app.aichanakya.in/"
                        : "https://calendly.com/atharv-gyem/discovery-call"
                    }
                    onClick={(e) =>
                      logEvent(
                        "CTA",
                        "Click",
                        `Banner CTA - ${
                          audienceType === "students"
                            ? "Start Learning"
                            : "Schedule Demo"
                        }`
                      )
                    }
                    target="_blank"
                  />
                  <CustomLink
                    linkText={
                      audienceType === "students"
                        ? "Meet Our AI Teachers"
                        : "Explore Features"
                    }
                    LinkTo={
                      audienceType === "students"
                        ? "#ai-teachers-section"
                        : "https://calendly.com/atharv-gyem/discovery-call"
                    }
                    onClick={(e) =>
                      audienceType === "students"
                        ? scrollToAITeachers(e)
                        : logEvent(
                            "CTA",
                            "Click",
                            "Banner Secondary CTA - Explore Features"
                          )
                    }
                    customClasses="secondary-cta"
                    target={audienceType === "students" ? "_self" : "_blank"}
                  />
                </div>

                <div className="trust-indicator">
                  <div className="trust-icons">
                    <div className="trust-icon">S</div>
                    <div className="trust-icon">T</div>
                    <div className="trust-icon">I</div>
                    <div className="trust-icon">+</div>
                  </div>
                  <span>
                    Trusted by <strong>3000+</strong> students 
                  </span>
                </div>
              </div>

              <div className="ai-chat-interface">
                <div className="chat-header">
                  <div className="chat-teacher-avatar">
                    <img
                      src={require("../assets/img/teacheravatar.svg").default}
                      alt="AI Teacher Avatar"
                      width="50"
                      height="50"
                    />
                  </div>
                  <div className="chat-teacher-info">
                    <h4>Ms. Priya</h4>
                    <p>Mathematics Specialist</p>
                  </div>
                </div>

                <div className="chat-messages">
                  <div className="message teacher">
                    <p>
                      I see you're struggling with quadratic equations. Let me
                      break it down step by step.
                    </p>

                    <p>The quadratic formula is:</p>
                    <div className="formula">x = (-b ± √(b² - 4ac)) / 2a</div>

                    <p>Let's apply it to your question where a=2, b=-7, c=3:</p>
                    <div className="formula">
                      x = (7 ± √(49 - 24)) / 4<br />
                      x = (7 ± √25) / 4<br />
                      x = (7 ± 5) / 4<br />
                      <br />
                      x₁ = 3, x₂ = 0.5
                    </div>

                    <p>
                      So the solutions are x = 3 and x = 0.5. Would you like to
                      practice with more examples?
                    </p>
                  </div>
                </div>

                <div className="chat-input">
                  <input
                    type="text"
                    placeholder="Ask your question..."
                    disabled
                  />
                  <button>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="student-results-section">
          <div className="container">
            <h2 className="section-title">Real Results from Real Students</h2>
            <p className="section-subtitle">
              See the measurable impact Chanakya AI has on academic performance
              and learning outcomes
            </p>
            <div className="results-grid">
              <div className="result-card">
                <div className="result-metric">Average 25%</div>
                <div className="result-label">Score Improvement</div>
                <p className="result-description">
                  Students see significant grade improvements within 3 months
                </p>
              </div>

              <div className="result-card">
                <div className="result-metric">90% Faster</div>
                <div className="result-label">Doubt Resolution</div>
                <p className="result-description">
                  Instant AI teacher responses vs traditional tutoring wait
                  times
                </p>
              </div>

              <div className="result-card">
                <div className="result-metric">3x More</div>
                <div className="result-label">Practice Questions</div>
                <p className="result-description">
                  Unlimited AI-generated questions vs limited textbook problems
                </p>
              </div>

              <div className="result-card">
                <div className="result-metric">24/7</div>
                <div className="result-label">Learning Support</div>
                <p className="result-description">
                  Round-the-clock access to AI teachers and study materials
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="ai-teachers-section" className="ai-teachers-section">
          <AITeachers />
        </section>

        <section className="student-learning-section">
          <div className="student-learning-card">
            <div className="student-learning-content">
              <div className="student-learning-header">
                <div className="student-section-badge">For Students</div>
                <h3 className="student-learning-title">
                  Your Personal Learning Revolution
                </h3>
                <p className="student-learning-subtitle">
                  Experience learning like never before with AI-powered
                  personalization that adapts to your unique needs and learning
                  style
                </p>
              </div>

              <div className="student-features-grid">
                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <svg
                      className="feature-icon"
                      viewBox="0 0 24 24"
                      width="32"
                      height="32"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                      <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                  </div>
                  <div className="feature-content">
                    <h4 className="feature-title">Personalized AI Teachers</h4>
                    <p className="feature-description">
                      Learn from specialized AI teachers that adapt to your
                      learning style and pace
                    </p>
                    <ul className="feature-bullet-list">
                      <li className="feature-bullet-item">
                        5+ subject specialists with distinct teaching styles
                      </li>
                      <li className="feature-bullet-item">
                        Adaptive learning paths based on your progress
                      </li>
                      <li className="feature-bullet-item">
                        Real-time doubt clearing and concept explanation
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <svg
                      className="feature-icon"
                      viewBox="0 0 24 24"
                      width="32"
                      height="32"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="8" y1="6" x2="21" y2="6"></line>
                      <line x1="8" y1="12" x2="21" y2="12"></line>
                      <line x1="8" y1="18" x2="21" y2="18"></line>
                      <line x1="3" y1="6" x2="3.01" y2="6"></line>
                      <line x1="3" y1="12" x2="3.01" y2="12"></line>
                      <line x1="3" y1="18" x2="3.01" y2="18"></line>
                    </svg>
                  </div>
                  <div className="feature-content">
                    <h4 className="feature-title">Smart Practice Sessions</h4>
                    <p className="feature-description">
                      Practice makes perfect with our intelligent question
                      generation system
                    </p>
                    <ul className="feature-bullet-list">
                      <li className="feature-bullet-item">
                        Unlimited subject-specific practice
                      </li>
                      <li className="feature-bullet-item">
                        Adaptive difficulty levels
                      </li>
                      <li className="feature-bullet-item">
                        Includes objective & subjective formats
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <svg
                      className="feature-icon"
                      viewBox="0 0 24 24"
                      width="32"
                      height="32"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                    </svg>
                  </div>
                  <div className="feature-content">
                    <h4 className="feature-title">
                      Instant Feedback & Analysis
                    </h4>
                    <p className="feature-description">
                      Get immediate, detailed feedback on your work to improve
                      faster
                    </p>
                    <ul className="feature-bullet-list">
                      <li className="feature-bullet-item">
                        Upload handwritten/digital answers
                      </li>
                      <li className="feature-bullet-item">
                        Detailed corrections and insights
                      </li>
                      <li className="feature-bullet-item">
                        Performance tracking across subjects
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <svg
                      className="feature-icon"
                      viewBox="0 0 24 24"
                      width="32"
                      height="32"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M18 20V10"></path>
                      <path d="M12 20V4"></path>
                      <path d="M6 20v-6"></path>
                    </svg>
                  </div>
                  <div className="feature-content">
                    <h4 className="feature-title">Progress Analytics</h4>
                    <p className="feature-description">
                      Visualize your learning journey with comprehensive
                      analytics
                    </p>
                    <ul className="feature-bullet-list">
                      <li className="feature-bullet-item">
                        Visual progress tracking
                      </li>
                      <li className="feature-bullet-item">
                        Pinpoint strengths and weaknesses
                      </li>
                      <li className="feature-bullet-item">
                        Goal-setting and recommendations
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="student-cta-container">
                <button
                  className="student-cta-button"
                  onClick={() =>
                    window.open(
                      "https://app.aichanakya.in/",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Start Your Learning Journey →
                </button>
                <p className="student-cta-subtext">
                  Free to start • No credit card required
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="institution-section">
          <div className="institution-container">
            <div className="institution-header">
              <div className="institution-section-badge">For Institutions</div>
              <h3 className="institution-title">
                Transform Your Educational Operations
              </h3>
              <p className="institution-subtitle">
                Streamline assessments, reduce costs, and improve outcomes with
                our AI-powered educational platform
              </p>
            </div>

            <div className="institution-features-grid">
              <div className="institution-feature-card">
                <div className="institution-feature-header">
                  <div className="institution-feature-icon-wrapper">
                    <svg
                      className="institution-feature-icon"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                  </div>
                  <div className="institution-feature-title-wrapper">
                    <h4 className="institution-feature-title">
                      Automated Assessment Creation
                    </h4>
                    <span className="institution-feature-highlight">
                      Save 300+ hours annually
                    </span>
                  </div>
                </div>
                <p className="institution-feature-description">
                  Generate CBSE-aligned question papers in minutes, not hours
                </p>
              </div>

              <div className="institution-feature-card">
                <div className="institution-feature-header">
                  <div className="institution-feature-icon-wrapper">
                    <svg
                      className="institution-feature-icon"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </div>
                  <div className="institution-feature-title-wrapper">
                    <h4 className="institution-feature-title">
                      AI-Powered Grading
                    </h4>
                    <span className="institution-feature-highlight">
                      Reduce grading costs by ₹50,000+/month
                    </span>
                  </div>
                </div>
                <p className="institution-feature-description">
                  Grade papers 90% faster with 99.5% accuracy
                </p>
              </div>

              <div className="institution-feature-card">
                <div className="institution-feature-header">
                  <div className="institution-feature-icon-wrapper">
                    <svg
                      className="institution-feature-icon"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 3v18h18"></path>
                      <path d="m18.4 8-5.4-5.4-5.4 5.4"></path>
                      <path d="m6.6 16 5.4-5.4 5.4 5.4"></path>
                    </svg>
                  </div>
                  <div className="institution-feature-title-wrapper">
                    <h4 className="institution-feature-title">
                      Detailed Analytics
                    </h4>
                    <span className="institution-feature-highlight">
                      Improve results by 30%
                    </span>
                  </div>
                </div>
                <p className="institution-feature-description">
                  Get comprehensive insights into student and class performance
                </p>
              </div>

              <div className="institution-feature-card">
                <div className="institution-feature-header">
                  <div className="institution-feature-icon-wrapper">
                    <svg
                      className="institution-feature-icon"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                  </div>
                  <div className="institution-feature-title-wrapper">
                    <h4 className="institution-feature-title">
                      Personalized Feedback
                    </h4>
                    <span className="institution-feature-highlight">
                      100% students get personalized insights
                    </span>
                  </div>
                </div>
                <p className="institution-feature-description">
                  Automatically generate detailed feedback for every student
                </p>
              </div>
            </div>

            <div className="institution-cta-container">
              <button
                className="institution-cta-button"
                onClick={() =>
                  window.open(
                    "https://calendly.com/atharv-gyem/discovery-call",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                Request Enterprise Demo →
              </button>
              <p className="institution-cta-subtext">
                Custom pricing • Dedicated support • Implementation assistance
              </p>
            </div>
          </div>
        </section>

        <section className="how-it-works-section">
          <HowItWorks />
        </section>


        <section className="google-startups-section">
          <div className="container">
            <GoogleStartupLogos />
          </div>
        </section>

        <section className="success-stories-section">
          <SuccessStories />
        </section>

        <section className="pricing-plans-section" id="pricing-section">
          <div className="container">
            <PricingPlans />
          </div>
        </section>

        <section className="get-in-touch-section">
          <div className="container" id="contact-form">
            <div className="contact-header">
              <div className="section-badge">Get in Touch</div>
              <h2 className="section-title">
                Ready to Transform Your Learning?
              </h2>
              <p className="section-subtitle">
                Whether you're a student looking to improve your grades, a
                parent seeking the best for your child, or an institution aiming
                to innovate, we're here to help.
              </p>
            </div>

            <div className="contact-columns">
              <div className="contact-form-column">
                <div className="card contact-card">
                  <div className="card-body">
                    <h3 className="contact-column-title">Send us a message</h3>

                    <form
                      id="contactForm"
                      className="get-in-touch-form"
                      onSubmit={(e) => {
                        e.preventDefault();
                        
                       
                        emailjs.sendForm(
                          process.env.REACT_APP_EMAILJS_SERVICE_ID, 
                          process.env.REACT_APP_EMAILJS_TEMPLATE_ID, 
                          e.target, 
                          process.env.REACT_APP_EMAILJS_PUBLIC_KEY
                        )
                          .then((result) => {

                            const userEmail = e.target.user_email.value;
                            const userName = e.target.user_name.value;
                            const userMessage = e.target.user_message.value;
                            

                            const messageTopic = userMessage.split('.')[0].substring(0, 50) + (userMessage.length > 50 ? '...' : '');
                            
                   
                            const autoReplyParams = {
                              to_name: userName,           
                              to_email: userEmail,         
                              user_name: userName,         
                              user_email: userEmail,       
                              message_topic: messageTopic,
                            };
                            
                         
                            emailjs.send(
                              process.env.REACT_APP_EMAILJS_SERVICE_ID, 
                              process.env.REACT_APP_EMAILJS_AUTO_REPLY_TEMPLATE_ID, 
                              autoReplyParams, 
                              process.env.REACT_APP_EMAILJS_PUBLIC_KEY
                            )
                              .then(() => {
                                console.log("Auto-reply sent successfully");
                              }, (error) => {
                                console.error("Error sending auto-reply:", error);
                              });
                            
                            document.getElementById("contactForm").style.display = "none";
                            document.getElementById("thankYouMessage").style.display = "block";
                            logEvent("Form", "Submit", "Contact Form");
                          }, (error) => {
                            console.error("Error:", error);

                          });
                      }}
                    >
                      <div className="form-row">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Name*"
                            name="user_name"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email Address*"
                            name="user_email"
                            required
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Institution (Optional)"
                          name="user_institution"
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Phone Number*"
                          name="user_phone"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          placeholder="Your Message*"
                          name="user_message"
                          rows="4"
                          required
                        ></textarea>
                      </div>
                      <button type="submit" className="submit-button">
                        Send Message
                      </button>
                    </form>

                    <div
                      id="thankYouMessage"
                      style={{ display: "none" }}
                      className="thank-you-message"
                    >
                      <h4>Thank you for getting in touch!</h4>
                      <p>
                        We've received your message and will contact you shortly
                        to discuss how Chanakya AI can transform your
                        institute's assessment process.
                      </p>
                      <button
                        className="submit-button"
                        onClick={() => {
                          document.getElementById("contactForm").style.display =
                            "block";
                          document.getElementById(
                            "thankYouMessage"
                          ).style.display = "none";
                          document.getElementById("contactForm").reset();
                        }}
                      >
                        Submit Another Message
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-info-column">
                <div className="contact-methods">
                  <div className="contact-method">
                    <div className="contact-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                    </div>
                    <div className="contact-info">
                      <h4>Email Us</h4>
                      <p>
                        <a href="mailto:support@aichanakya.in">
                          support@aichanakya.in
                        </a>
                      </p>
                      <p>
                        <a href="mailto:sales@aichanakya.in">
                          sales@aichanakya.in
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="contact-method">
                    <div className="contact-icon">
                      <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                      </svg>
                    </div>
                    <div className="contact-info">
                      <h4>Call Us</h4>

                      <p>+91 9876543210</p>
                      <p className="contact-time">Mon–Fri 9AM–6PM IST</p>
                    </div>
                  </div>
                </div>

                <div className="cta-cards">
                  <div className="cta-card student-cta">
                    <h4>For Students</h4>
                    <p>Start your personalized learning journey today</p>
                    <a
                      className="cta-button"
                      href="https://app.aichanakya.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Start Learning Free
                    </a>
                  </div>

                  <div className="cta-card institution-cta">
                    <h4>For Institutions</h4>
                    <p>Request a demo of our enterprise solutions</p>
                    <a
                      className="cta-button secondary-cta"
                      href="https://calendly.com/atharv-gyem/discovery-call"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Request Enterprise Demo
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-section">
          <Faq
            faqQuestion={[
              {
                id: 1,
                question: "How does Chanakya AI's assessment system work?",
                answere:
                  "Chanakya AI uses advanced artificial intelligence to automatically create exams, check handwritten and digital answers, and provide detailed performance analytics. Our system can understand and evaluate student responses with 99% accuracy, saving teachers hours of grading time while providing consistent, unbiased assessments.",
              },
              {
                id: 2,
                question: "How much time can teachers save with Chanakya AI?",
                answere:
                  "Teachers typically save 30% of their workload with our platform. What used to take hours of manual grading can now be completed in minutes, allowing educators to focus more on teaching and less on administrative tasks.",
              },
              {
                id: 3,
                question:
                  "Is Chanakya AI suitable for all subjects and grade levels?",
                answere:
                  "Yes, our platform is designed to work across all subjects and grade levels. Whether you're teaching mathematics, sciences, humanities, or languages, Chanakya AI can handle various question types and assessment formats.",
              },
              {
                id: 4,
                question: "How accurate is the AI grading system?",
                answere:
                  "Our AI grading system achieves over 99% accuracy when compared to expert human graders. The system has been trained on millions of student responses and continuously improves through machine learning.",
              },
              {
                id: 5,
                question: "How can I get started with Chanakya AI?",
                answere:
                  "Getting started is easy! Simply schedule a demo with our team, and we'll walk you through the platform and set up a pilot program tailored to your institution's needs. We provide comprehensive onboarding and support throughout the implementation process.",
              },
            ]}
          />
        </section>

        <section className="powerUp-section">
          <div className="container">
            <div className="tag-main">
              <h3 className="section-tag">Power Up Your Learning</h3>
            </div>
            <p className="powerUp-text">
              Give your students quicker, better, more insightful feedback on
              their tests
            </p>
            <div className="accessBox-main">
              <CustomLink
                linkText="Start Learning &nbsp;"
                customClasses="access-btn"
                LinkTo="https://app.aichanakya.in/"
                target="_blank"
              />
               
            </div>
          </div>
        </section>
      </main>
      <OuterFooter />
      <div className="floating-buttons">
        <button
          className="floating-whatsapp-button"
          onClick={() => {
            window.open("https://chat.whatsapp.com/Dj537r8v1mS5AgWh1yGGtt?mode=ac_c", "_blank");
            logEvent("CTA", "Click", "Floating WhatsApp Button");
          }}
          aria-label="Chat on WhatsApp"
        >
          <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="currentColor"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.516z"/>
          </svg>
        </button>
        
        <button
          className="floating-call-button"
          onClick={(e) => scrollToContactForm(e, "Floating Call Button")}
          aria-label="Contact Us"
        >
          <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default EducationPage;
